<div class="asset-discussion-list">
  <div
    *ngFor="let discussion of discussions"
    class="asset-discussion-list--item"
    [class.pinned]="discussion.isPinned"
    [class.bookmarked]="discussion.isBookmarked"
    (click)="onNavigate(discussion.id)"
  >
    <div *ngIf="discussion.isBookmarked" class="asset-discussion-list--bookmark-ribbon" title="Bookmarked">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V19L12 15L5 19V5Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="asset-discussion-list--content">
      <div class="asset-discussion-list--row asset-discussion-list--row-top">
        <div class="asset-discussion-list--title-group">
          <h4 class="asset-discussion-list--title">{{ discussion.title }}</h4>
        </div>
        <span class="asset-discussion-list--tag">{{ assetTypeLabel }}</span>
      </div>
      <div class="asset-discussion-list--row asset-discussion-list--row-bottom">
        <div class="asset-discussion-list--meta-group">
          <span class="asset-discussion-list--author">{{ discussion.author }}</span>
        </div>
      </div>
      <div class="asset-discussion-list--row asset-discussion-list--row-stats">
        <div class="asset-discussion-list--stats-group">
          <span class="asset-discussion-list--timestamp">{{ discussion.lastActivity }}</span>
        </div>
        <div class="asset-discussion-list--actions">
          <button class="asset-discussion-list--arrow" aria-label="View discussion" type="button" (click)="onNavigate(discussion.id, $event)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
